<template>
  <div class="homework-topbar">
    <div class="homework-list-topbar">
      <div class="topbar-operation">
        <div class="operation-left">
          <div class="sensitiveWord-select-t">
            当前班级：
            <el-cascader
              v-model="classNameVal"
              :placeholder="classPlaceholder"
              :props="classProps"
              :options="classSelect"
              @change="changeHandle"
            ></el-cascader>
          </div>
        </div>
        <div class="operation-right">
          <el-date-picker
            v-model="isDatePickerShow"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期筛选考勤"
            size="large"
            :clearable="false"
            @change="datePickerChange"
          >
          </el-date-picker>
        </div>
      </div>
    </div>
    <div class="topbar-tabs">
      <div
        class="tab-item"
        :class="currentCourseItem == index ? 'current-item' : ''"
        v-for="(item, index) in courseList"
        :key="index"
        @click="changeCurrentTabItem(index)"
        :style="{ 'animation-duration': `${(index + 1) * 0.2}s` }"
      >
        {{ item.courseName ? item.courseName : "全部" }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      currentCourseItem: 0,
      isDatePickerShow: "",
      classNameVal: [],
      // className: "",
    };
  },
  created() {
    // this.className =
    //   this.classInfo.currentClass.gradeName +
    //   this.classInfo.currentClass.className;
  },
  mounted() {
    this.isDatePickerShow = this.today;
    this.classNameVal = this.className;
    // console.log("今天的时间==>", this.isDatePickerShow);
  },
  // props: {
  //   courseList: {
  //     type: Array,
  //     require: true,
  //   },
  //   today: {
  //     type: String,
  //   },
  // },
  props: [
    "className",
    "classPlaceholder",
    "classProps",
    "classSelect",
    "courseList",
    "today",
  ],
  methods: {
    // 选择班级
    changeHandle(e) {
      // console.log("选中的班级==>", e);
      this.$emit("changeHandle", e);
    },
    changeCurrentTabItem(tabsIndex) {
      this.currentCourseItem = tabsIndex;
      this.$emit("input", this.currentCourseItem);
    },
    // showDatePicker() {
    //   this.isDatePickerShow = true;
    // },
    datePickerChange(e) {
      // console.log("选择的日期==>", e);
      this.$emit("pickDate", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./attendance-topbar.scss";
</style>